export const setSurveyOptionsForSelectOption = (surveys) => {
  return surveys?.map(survey => {
    return {
      value: survey.id,
      label: survey.name
    }
  });
}

